import React from "react"
import Style from "../styles/footer.module.css"

export default (props) => (
    <footer className={Style.footer}>
        <p>声明:网站内容均来自网络，版权归原作者所有，如有侵权请告知删除 。站长邮箱：linghuiazy@gmail.com</p>
    </footer>
)